import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AccountOverview from './Components/Dashboard/AccountOverview';
import PaymentMethod from './Components/Dashboard/PaymentMethod';
import CreateViewPage from './Components/Dashboard/CreateViewPage';
import AddViewPeople from './Components/Dashboard/AddViewPeople';
import Campaigns from './Components/Campaigns/Campaigns';
import BasicInfo from './Components/Campaigns/BasicInfo';
import Media from './Components/Campaigns/Media';
import Parameters from './Components/Campaigns/Parameters';
import LeadGeneration from './Components/Campaigns/LeadGeneration';
import Audiences from './Components/Audiences/Audiences';
import CreateAudience from './Components/Audiences/CreateAudience';
import People from './Components/AccountSetting/People';
import Audience from './Components/AccountSetting/Audience';
import Placement from './Components/AccountSetting/Placement';
import Notification from './Components/AccountSetting/Notification';
import TwoFactorAuthentication from './Components/AccountSetting/TwoFactorAuthentication';
import PaymentSetting from './Components/BillingPayment/PaymentSetting';
import PaymentActivity from './Components/BillingPayment/PaymentActivity';
import TransactionDetail from './Components/BillingPayment/TransactionDetail';
import Home from './Components/Home/Home';
import Dashboard from './Components/Dashboard/Dashboard';
import AccountSetting from './Components/AccountSetting/AccountSetting';
import BillingPayment from './Components/BillingPayment/BillingPayment';
import Help from './Components/Help/Help';
import CreateCampaign from './Components/Campaigns/CreateCampaign';
import Check from './Components/Check/Check';


const RoutesPage = () => {
  return (
    <>
      <Router>
        <Routes>

          {/* Home */}
          <Route exact path="/" element={<Home />} >

            {/* Dashboard */}
            <Route exact path="/dashboard" element={<Dashboard />} >
              <Route exact path='account-overview' element={<AccountOverview />} />
              <Route exact path='payment-method' element={<PaymentMethod />} />
              <Route exact path='create-view-page' element={<CreateViewPage />} />
              <Route exact path='add-view-people' element={<AddViewPeople />} />
            </Route>

            {/* Campaigns */}
            <Route exact path="/campaigns" element={<Campaigns />} />

            <Route path="/campaigns" element={<CreateCampaign />} >
              <Route path='basic-info' element={<BasicInfo />} />
              <Route path='media' element={<Media />} />
              <Route path='parameters' element={<Parameters />} />
              <Route path='lead-generation' element={<LeadGeneration />} />
            </Route>

            {/* Audience */}
            <Route exact path="/audiences" element={<Audiences />} />
            <Route exact path="/create-audience" element={<CreateAudience />} />

            {/* Account Setting */}
            <Route path="/account-setting" element={<AccountSetting />} >
              <Route path='people' element={<People />} />
              <Route path='audience' element={<Audience />} />
              <Route path='placement' element={<Placement />} />
              <Route path='notification' element={<Notification />} />
              <Route path='two-factor-authentication' element={<TwoFactorAuthentication />} />
            </Route>

            {/* Billing & Payments */}
            <Route path="/billing-payment" element={<BillingPayment />} >
              <Route path='payment-setting' element={<PaymentSetting />} />
              <Route path='payment-activity' element={<PaymentActivity />} />
              <Route path='transaction-detail' element={<TransactionDetail />} />
            </Route>

            {/* Help */}
            <Route exact path="/help" element={<Help />} />
            
            <Route exact path="/check" element={<Check />} />

          </Route>
          
        </Routes>
      </Router>
    </>
  );
};

export default RoutesPage;